import React, {
  useEffect,
  useState,
} from "react";

import useApi from "../../CustomHooks/useApi";
import { ufgAPI } from "../../../api/apiClient";
import Loading from "../../../Loading";

import TfgPreviewItem from "./TfgPreviewItem";
import TfgPreviewListItem from "./TfgPreviewListItem";

import "../../../css/Views/TfgPreviewDialog.css";

const EXPORT_TYPE_LABELS = {
  1: "NOWE DANE",
  2: "KOREKTA",
  3: "ROZWIĄZANIE",
  4: "USUNIĘCIE",
};

const TfgPreviewDialog = ({
  onClose,
}) => {
  const {
    callApi,
    isLoading,
  } = useApi();

  const [preview, setPreview] =
    useState(null);

  const [
    selectedItemId,
    setSelectedItemId,
  ] = useState(null);

  const loadPreview = async () => {
    await callApi(
      () => ufgAPI.getTfgPreview(),
      (result) => {
        setPreview(result);

        const firstItem =
          result?.items?.[0];

        setSelectedItemId(
          firstItem?.reservationId ?? null
        );
      }
    );
  };

  useEffect(() => {
    loadPreview();
  }, []);

  const items =
    preview?.items ?? [];

  const selectedItem =
    items.find(
      (item) =>
        item.reservationId ===
        selectedItemId
    ) ?? items[0];

  const exportTypeLabel = preview
    ? EXPORT_TYPE_LABELS[
        preview.type
      ] ?? "Nieznany typ"
    : null;

  return (
    <div
      className="tfg-dialog-backdrop"
      role="presentation"
      onMouseDown={onClose}
    >
      <div
        className="tfg-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tfg-preview-title"
        onMouseDown={(event) =>
          event.stopPropagation()
        }
      >
        <div className="tfg-dialog-header">
          <div>
            <h2
              id="tfg-preview-title"
              className="tfg-dialog-title"
            >
              Podgląd eksportu
            </h2>

            <div className="tfg-dialog-subtitle">
              {preview
                ? `${exportTypeLabel} · ${items.length} ${
                    items.length === 1
                      ? "umowa"
                      : "umowy"
                  }`
                : "Dane, które zostaną zapisane w następnym eksporcie."}
            </div>
          </div>

          <button
            type="button"
            className="tfg-dialog-close"
            onClick={onClose}
            aria-label="Zamknij podgląd"
          >
            ×
          </button>
        </div>

        <div className="tfg-dialog-content">
          {isLoading && (
            <Loading text="Ładowanie podglądu..." />
          )}

          {!isLoading && !preview && (
            <div className="tfg-preview-error">
              <div>
                Nie udało się pobrać
                podglądu eksportu.
              </div>

              <button
                type="button"
                className="tfg-button tfg-button--primary"
                onClick={loadPreview}
              >
                Spróbuj ponownie
              </button>
            </div>
          )}

          {!isLoading &&
            preview &&
            items.length === 0 && (
              <div className="tfg-preview-empty">
                Brak umów w podglądzie
                eksportu.
              </div>
            )}

          {!isLoading &&
            items.length > 0 && (
              <div className="tfg-preview-layout">
                <aside className="tfg-preview-sidebar">
                  <div className="tfg-preview-sidebar-title">
                    Umowy w eksporcie
                  </div>

                  <div className="tfg-preview-sidebar-list">
                    {items.map((item) => (
                      <TfgPreviewListItem
                        key={
                          item.reservationId
                        }
                        item={item}
                        isSelected={
                          item.reservationId ===
                          selectedItem?.reservationId
                        }
                        onClick={() =>
                          setSelectedItemId(
                            item.reservationId
                          )
                        }
                      />
                    ))}
                  </div>
                </aside>

                <main className="tfg-preview-details">
                  {selectedItem && (
                    <TfgPreviewItem
                      item={selectedItem}
                    />
                  )}
                </main>
              </div>
            )}
        </div>

        <div className="tfg-dialog-actions">
          <button
            type="button"
            className="tfg-button tfg-button--secondary"
            onClick={onClose}
          >
            Zamknij
          </button>
        </div>
      </div>
    </div>
  );
};

export default TfgPreviewDialog;